import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import { PageHeader } from "@/components/PageHeader";
import { Notify } from "@/components/ui/notify";
import { AuditFilters } from "./AuditFilters";
import { AuditTable } from "./AuditTable";
import { AuditDiffCard } from "./AuditDiffCard";
import type { AuditListResponse } from "./helpers";

export function AuditPage() {
  const [entityType, setEntityType] = useState("");
  const [action, setAction] = useState("");
  const [offset, setOffset] = useState(0);
  const limit = 50;
  const [expanded, setExpanded] = useState<string | null>(null);

  const query = useQuery<AuditListResponse>({
    queryKey: ["audit", entityType, action, offset],
    queryFn: () => {
      const params = new URLSearchParams();
      if (entityType) params.set("entityType", entityType);
      if (action) params.set("action", action);
      params.set("offset", String(offset));
      params.set("limit", String(limit));
      return api.get(`/api/v1/audit?${params.toString()}`);
    },
  });

  const total = query.data?.total ?? 0;
  const entries = query.data?.items ?? [];
  const expandedEntry = expanded ? entries.find((e) => e.id === expanded) : undefined;

  return (
    <section>
      <PageHeader
        title="Auditoria"
        subtitle={`${total} registro(s) — todas as mutações são imutáveis.`}
      />

      <AuditFilters
        entityType={entityType}
        action={action}
        offset={offset}
        limit={limit}
        total={total}
        onEntityTypeChange={(v) => {
          setEntityType(v);
          setOffset(0);
        }}
        onActionChange={(v) => {
          setAction(v);
          setOffset(0);
        }}
        onOffsetChange={setOffset}
      />

      {query.isError ? (
        <Notify.QueryError error={query.error} onRetry={() => void query.refetch()} />
      ) : query.isLoading ? (
        <p className="text-sm text-muted-foreground">Carregando…</p>
      ) : (
        <AuditTable
          entries={entries}
          expandedId={expanded}
          onToggleExpand={(id) => setExpanded(expanded === id ? null : id)}
        />
      )}

      {expandedEntry ? <AuditDiffCard entry={expandedEntry} /> : null}
    </section>
  );
}
